// import { motion } from 'framer-motion';
// import React from 'react'
// import { NavLink } from 'react-router-dom';
// import styled from 'styled-components';
// import { Github } from '../components/AllSvgs';



// const Box = styled(motion.li)`
// width: 16rem;
// height: 40vh;
// background-color: ${props => props.theme.text};
// color:${props => props.theme.body};
// padding: 1.5rem 2rem;
// margin-right: 8rem;
// border-radius: 0 50px 0 50px;
// display: flex;
// flex-direction: column;
// justify-content: space-between;
// border: 1px solid ${props => props.theme.body};
// transition: all 0.2s ease;

// &:hover{
// background-color: ${props => props.theme.body};
// color:${props => props.theme.text};
// border: 1px solid ${props => props.theme.text};

// }
// `
// const Title = styled.h2`
// font-size: calc(1em + 0.5vw);
// `

// const Description = styled.h2`
// font-size: calc(0.8em + 0.3vw);
// font-family: 'Karla',sans-serif;
// font-weight: 500;
// `
// const Tags = styled.div`
// border-top: 2px solid ${props =>props.theme.body};
// padding-top: 0.5rem;
// display:flex;
// flex-wrap:wrap;
// ${Box}:hover &{
// border-top: 2px solid ${props =>props.theme.text};
// }
// `
// const Tag = styled.span`
// margin-right:1rem;
// font-size:calc(0.8em + 0.3vw);
// `

// const Footer = styled.footer`
// display: flex;
// justify-content: space-between;
// `

// const Link = styled.a`
// background-color: ${props =>props.theme.body};
// color: ${props =>props.theme.text};
// text-decoration: none;
// padding:0.5rem calc(2rem + 2vw);
// border-radius: 0 0 0 50px;
// font-size:calc(1em + 0.5vw);

// ${Box}:hover &{
//     background-color: ${props =>props.theme.text};
//     color: ${props =>props.theme.body};

// }
// `

// const Git = styled.a`
// color: inherit;
// text-decoration: none;
// ${Box}:hover &{
//     &>*{
//         fill:${props =>props.theme.text};
//     }
// }

// `

// // Framer motion configuration
// const Item = {
//     hidden:{
//         scale:0
//     },
//     show:{
//         scale:1,
//         transition: {
//             type: 'spring',
//             duration: 0.5
//         }
//     }
// }

// const Card = (props) => {

//     const {id, name, description, tags, demo, github} = props.data;

//     return (
//         <Box key={id} variants={Item}>
//             <Title>{name}</Title>
//             <Description>
//                 {description}
//             </Description>
//             <Tags>
//             {
//                     tags.map((t,id) => {
//                         return <Tag key={id}>#{t}</Tag>
//                     })
//                 }
//             </Tags>
//             <Footer>
//                 <Link href={demo} target="_blank">
//                     Visit
//                 </Link>
//                 <Git  href={github}  target="_blank">
//                     <Github width={30} height={30} />
//                 </Git>
//             </Footer>
//         </Box>
//     )
// }

// export default Card


import { motion } from 'framer-motion';
import React, { useState } from 'react'; // Import useState
import styled from 'styled-components';
import { Github } from '../components/AllSvgs';

// 1. The Container
const Box = styled(motion.li)`
  width: 19rem;
  height: 45vh;
  background-color: transparent;
  margin-right: 5rem;
  perspective: 1000px;
  flex-shrink: 0;
  list-style: none;
  cursor: pointer;
  position: relative; /* Essential for absolute children */
  
  /* Stack Order Management */
  z-index: ${props => props.isFlipped ? 100 : 1};
  transition: z-index 0.1s;
`;

const FlipCardInner = styled(motion.div)`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
`;

const Face = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
  /* --- THE FIX: Keeps padding inside the box dimensions --- */
  box-sizing: border-box; 
  /* ------------------------------------------------------- */
  
  padding: 1.5rem 2rem;
  border-radius: 0 50px 0 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid ${props => props.theme.body};
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  overflow: hidden; /* Added safety to clip any child content */
`;

const FrontFace = styled(Face)`
  background-color: ${props => props.theme.text};
  color: ${props => props.theme.body};
  z-index: 2; 
  transform: rotateY(0deg);
`;

const BackFace = styled(Face)`
  background-color: ${props => props.theme.body};
  color: ${props => props.theme.text};
  border: 1px solid ${props => props.theme.text};
  transform: rotateY(180deg); 
`;

const Title = styled.h2`
  font-size: calc(1em + 0.5vw);
  padding-top:30px;
`;

const Description = styled.h2`
  padding-bottom:30px;
  font-size: calc(0.8em + 0.3vw);
  font-family: 'Karla', sans-serif;
  font-weight: 500;
`;

const FlipWatermark = styled.span`
  position: absolute;
  right: 1.2rem;
  bottom: 1rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
  opacity: 0.32;
  transform: rotate(-18deg);
  pointer-events: none;
`;

const Image = styled.div`
  background-image: url(${props => props.img});
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 40%;
  border-radius: 0 20px 0 20px;
  border: 1px solid ${props => props.theme.text};
  margin-bottom: 1rem;
`;

const Tags = styled.div`
  border-top: 2px solid ${props => props.theme.text};
  padding-top: 0.5rem;
  display: flex;
  flex-wrap: wrap;
`;

const Tag = styled.span`
  margin-right: 1rem;
  font-size: calc(0.8em + 0.3vw);
`;

const Footer = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Link = styled.a`
  background-color: ${props => props.theme.text};
  color: ${props => props.theme.body};
  text-decoration: none;
  padding: 0.5rem calc(2rem + 2vw);
  border-radius: 0 0 0 50px;
  font-size: calc(0.6em + 0.5vw);
  font-weight: bold;
  transition: all 0.2s ease;
  cursor: pointer;
`;

const Git = styled.a`
  color: inherit;
  text-decoration: none;
  & > * {
    fill: ${props => props.theme.text};
  }
`;

const Item = {
  hidden: { scale: 0 },
  show: {
    scale: 1,
    transition: {
      type: 'spring',
      duration: 0.5
    }
  }
};

const Card = (props) => {
  const { id, name, description, tags, demo, github, img } = props.data;
  
  // State to handle Flip (works for both Click and Hover)
  const [iscardflipped, setIsFlipped] = useState(false);

  // Mobile: Click to flip
  const handleClick = () => {
    setIsFlipped(!iscardflipped);
  };

  // Desktop: Hover to flip
  const handleMouseEnter = () => {
    setIsFlipped(true);
  };
  
  const handleMouseLeave = () => {
    setIsFlipped(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setIsFlipped((prev) => !prev);
    }
  };

  return (
    <Box 
        key={id} 
        variants={Item}
        isFlipped={iscardflipped}
        onClick={handleClick} // Mobile Support
        onMouseEnter={handleMouseEnter} // Desktop Support
        onMouseLeave={handleMouseLeave} // Desktop Support
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label={`${name} project card`}
        aria-pressed={iscardflipped}
    >
      <FlipCardInner 
        // We use 'animate' instead of 'whileHover' so we can control it via state
        initial={false}
        animate={{ rotateY: iscardflipped ? 180 : 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* FRONT */}
        <FrontFace>
          <Title>{name}</Title>
          <Description>{description}</Description>
          <FlipWatermark>Flip for details</FlipWatermark>
        </FrontFace>

        {/* BACK */}
        <BackFace>
          <Image img={img} />
          <Tags>
            {tags.map((t, id) => {
              return <Tag key={id}>#{t}</Tag>;
            })}
          </Tags>
          <Footer>
             {/* stopPropagation prevents the card from flipping back when you click the button */}
            <Link href={demo} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
                Visit
            </Link>
            <Git href={github} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
              <Github width={30} height={30} />
            </Git>
          </Footer>
        </BackFace>

      </FlipCardInner>
    </Box>
  );
};

export default Card;